<template>
  <aigentiq-chat
    v-if="chatbotUrl && chatbotSiteId"
    :site-id="chatbotSiteId"
    locale="auto">
  </aigentiq-chat>
</template>

<script>
import LoggingService from '@/common/LoggingService'
import PropertyService from '@/common/PropertyService'

export default {
  name: 'CsoChatbot',

  computed: {
    chatbotUrl () {
      return PropertyService.chatbotUrl
    },
    chatbotSiteId () {
      return PropertyService.chatbotSiteId
    }
  },

  mounted () {
    try {
      this.load()
    } catch (error) {
      LoggingService.error(LoggingService.eventTypes.marketing, 'Loading Chatbot failed', error)
    }
  },

  methods: {
    load () {
      const url = this.chatbotUrl
      if (!url || !this.chatbotSiteId) {
        return
      }
      const alreadyLoaded = [...document.scripts].some(script => script.src === url)
      if (alreadyLoaded) {
        return
      }

      const script = document.createElement('script')
      script.type = 'module'
      script.async = true
      script.src = url
      document.head.appendChild(script)
    }
  }
}
</script>
